module.exports = __webpack_public_path__ + "img/classic-guestroom-img.fa1689bf.jpg";